import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 * "list-item" 에서 Link 혹은 a 사용시 validateDOMNesting \<a\> cannot appear as a descendant of <a> 경고가 발생하는것을 막기위함. 
 * @param {pathname} pathname 이동할 경로.
 * @param {state} state 이동시 전달할 변수들의 집합.
 * @returns 
 */

function ALinkNested({ children, pathname, state, style, ...rest }) {
    const history = useHistory();
    return (
        <div style={style || { margin: '1px' }} onClick={(evt) => {
            evt.preventDefault();
            history.push({
                pathname,
                state
            });
        }}>{children}</div>
    );
};

export default ALinkNested;